var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.currentPath),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":item}},[_vm._v("\n      "+_vm._s(_vm.itemTitle(item))+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }